import clsx from "clsx"
import { lazy, Suspense } from "react"
import { useGlobal } from "@/app/store/global"
import { AppNotifications } from "@/features/app-notifications.tsx"
import { LanguageChanger } from "@/features/language-changer.tsx"
import { UserProfile } from "@/features/user-profile.tsx"
import { Loader, MenuExpendLeftLine, Toggle } from "@/shared/components/ui/icons"
import { useMediaQuery } from "@/shared/hooks/use-media-query.ts"
import { CustomIconButton } from "@/shared/ui/custom-icon-button.tsx"
import { useCurrentUser } from "@/shared/hooks/use-current-user"

const ThemeChanger = lazy(() => import("@/features/theme-changer.tsx"))

export const TopMenu = () => {
  // Helpers
  const isLaptop = useMediaQuery("(max-width: 1200px)")
  const { isCompany } = useCurrentUser()

  // Store
  const isOpen = useGlobal(state => state.sidebarIsOpened)

  return (
    <div className="top-menu">
      <div>
        {isLaptop ? (
          <div className="flex h-10 w-10 cursor-pointer items-center justify-center *:*:fill-red-400" onClick={useGlobal.toggleSidebar}>
            <Toggle size={24} className="text-icon-color" />
          </div>
        ) : (
          <div className="cursor-pointer" onClick={useGlobal.toggleSidebar}>
            <MenuExpendLeftLine size={40} className={clsx("text-icon-color transition", !isOpen && " rotate-180 transition")} />
          </div>
        )}
      </div>
      {/*<DevelopmentUserRoleButtons />*/}
      <div className="gap-3">
        <LanguageChanger />
        <Suspense
          fallback={
            <CustomIconButton>
              <Loader className="animate-spin duration-300" />
            </CustomIconButton>
          }
        >
          <ThemeChanger />
        </Suspense>
        {isCompany && <AppNotifications />}
        <UserProfile />
      </div>
    </div>
  )
}
